import { useState, useEffect } from "react";
import axios from "axios";

export default function PositionsPanel({ positions, API, onRefresh }) {
  const [exitPrice, setExitPrice] = useState("");
  const [notes, setNotes] = useState("");
  const [prices, setPrices] = useState({});

  useEffect(() => {
    if (!positions || !positions.length) return;
    const fetchPrices = async () => {
      try { const res = await axios.get(API + "/prices"); setPrices(res.data); } catch (e) {}
    };
    fetchPrices();
    const interval = setInterval(fetchPrices, 10000);
    return () => clearInterval(interval);
  }, [positions, API]);

  const closeTrade = async (tradeId) => {
    if (!exitPrice) return alert("Enter an exit price first");
    await axios.post(API + "/trade/" + tradeId + "/close", { exit_price: parseFloat(exitPrice), exit_reason: "manual", notes });
    setExitPrice(""); setNotes(""); onRefresh();
  };

  const getUnrealizedPnL = (pos) => {
    const p = prices[pos.symbol];
    if (!p || p.error) return null;
    const cur = pos.action === "buy" ? p.bid : p.ask;
    return ((cur - pos.entry_price) * pos.quantity * (pos.action === "buy" ? 1 : -1)).toFixed(2);
  };

  return (
    <div style={card}>
      <h2 style={heading}>Open Positions</h2>
      {!positions || !positions.length ? (<p style={empty}>No open positions</p>) : (
        positions.map(pos => {
          const pd = prices[pos.symbol];
          const cp = pd && !pd.error ? pd.mid : null;
          const upnl = getUnrealizedPnL(pos);
          return (
            <div key={pos.id} style={posItem}>
              <div style={itemHeader}>
                <span style={sym}>{pos.symbol}</span>
                <div style={{ display: "flex", gap: "6px" }}>
                  <span style={{ ...badge, background: pos.instrument_type === "forex" ? "#185FA5" : pos.instrument_type === "commodity" ? "#E8A838" : "#6B4FAC" }}>
                    {(pos.instrument_type || "equity").toUpperCase()}
                  </span>
                  <span style={{ ...badge, background: pos.mode === "paper_auto" ? "#0F6E56" : "#993C1D" }}>
                    {pos.mode.toUpperCase()}
                  </span>
                </div>
              </div>
              <div style={grid}>
                <span style={lbl}>Strategy</span><span style={val}>{pos.strategy || "-"}</span>
                <span style={lbl}>Action</span>
                <span style={{ ...val, color: pos.action === "buy" ? "#1D9E75" : "#e24b4a" }}>{pos.action ? pos.action.toUpperCase() : "-"}</span>
                <span style={lbl}>Entry</span><span style={val}>{pos.entry_price}</span>
                <span style={lbl}>Current Price</span>
                <span style={{ ...val, color: "#FFD700" }}>{cp ? cp.toFixed(5) : "-"}</span>
                <span style={lbl}>Unrealized PnL</span>
                <span style={{ ...val, color: upnl > 0 ? "#1D9E75" : upnl < 0 ? "#e24b4a" : "#888" }}>{upnl !== null ? "$" + upnl : "-"}</span>
                <span style={lbl}>Stop Loss</span><span style={val}>{pos.stop_loss ? pos.stop_loss.toFixed(5) : "-"}</span>
                <span style={lbl}>Take Profit</span><span style={val}>{pos.take_profit ? pos.take_profit.toFixed(5) : "-"}</span>
                <span style={lbl}>Planned RR</span><span style={val}>{pos.planned_rr}</span>
                <span style={lbl}>Quantity</span><span style={val}>{pos.quantity} {pos.instrument_type === "equity" ? "shares" : "units"}</span>
                <span style={lbl}>Opened</span><span style={val}>{pos.opened_at ? pos.opened_at.split("T")[0] : "-"}</span>
              </div>
              <div style={{ marginTop: "12px" }}>
                <input type="number" placeholder="Exit price" value={exitPrice} onChange={e => setExitPrice(e.target.value)} style={input} />
                <input type="text" placeholder="Notes (optional)" value={notes} onChange={e => setNotes(e.target.value)} style={{ ...input, marginTop: "6px" }} />
                <button onClick={() => closeTrade(pos.id)} style={closeBtn}>Close Trade</button>
              </div>
            </div>
          );
        })
      )}
    </div>
  );
}

const card = { background: "#1a1a1a", borderRadius: "12px", padding: "20px", border: "1px solid #2a2a2a" };
const heading = { margin: "0 0 16px", fontSize: "14px", fontWeight: "600", color: "#ffffff", textTransform: "uppercase", letterSpacing: "0.5px" };
const empty = { color: "#555", fontSize: "13px", textAlign: "center", padding: "20px 0" };
const posItem = { background: "#222", borderRadius: "8px", padding: "12px", marginBottom: "10px", border: "1px solid #333" };
const itemHeader = { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" };
const sym = { fontWeight: "700", fontSize: "15px", color: "#fff" };
const badge = { padding: "2px 8px", borderRadius: "12px", fontSize: "11px", color: "#fff", fontWeight: "600" };
const grid = { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "4px", fontSize: "12px" };
const lbl = { color: "#666" };
const val = { color: "#ccc", fontWeight: "500" };
const input = { width: "100%", padding: "8px", borderRadius: "6px", border: "1px solid #333", background: "#111", color: "#fff", fontSize: "13px", boxSizing: "border-box" };
const closeBtn = { marginTop: "8px", width: "100%", padding: "8px", borderRadius: "8px", border: "none", background: "#e24b4a", color: "#fff", fontSize: "13px", fontWeight: "600", cursor: "pointer" };
